import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ROUTES } from './account.routes';
import * as fromComponents from './components';
import * as fromContainers from './containers';
import * as fromStore from './store';
import * as fromGuards from './guards';
import { I2gNgUiModule } from 'i2g-ng-ui';
import { TranslateModule } from '@ngx-translate/core';
import { I2gNgTrackingModule } from 'i2g-ng-tracking';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(ROUTES),
    EffectsModule.forFeature([...fromStore.effects]),
    StoreModule.forFeature(fromStore.FEATURE_NAME, fromStore.reducer),
    ReactiveFormsModule,
    TranslateModule,
    I2gNgUiModule,
    I2gNgTrackingModule,
  ],
  declarations: [...fromContainers.containers, ...fromComponents.components],
  exports: [],
})
export class AccountModule {
  static forRoot(): ModuleWithProviders<AccountModule> {
    return {
      ngModule: AccountModule,
      providers: [
        ...fromGuards.guards,
        ...fromStore.services,
        ...fromStore.stores,
        ...fromStore.dispatchers,
      ],
    };
  }
}
